/* eslint-disable import/prefer-default-export */
import * as Filter from './filter.alerts.reducer'
import type * as Actions from '@src/redux/actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { defaultState, AlertsState, AlertDetails } from './default.state'

export function reducer(
  state = defaultState,
  action: Actions.Alerts.ActionTypes | Actions.AlertFilter.ActionTypes
): AlertsState {
  switch (action.type) {
    case ActionTypes.Alerts.GET_ALERTS_LIST_SUCCESS: {
      return {
        ...state,
        alertsList: action.payload.alertsList,
        alertTabs: action.payload.alertTabs,
        pagesCount: action.payload.pagesCount,
        highCount: action.payload.highCount,
        mediumCount: action.payload.mediumCount,
        lowCount: action.payload.lowCount,
        totalCount: action.payload.totalCount,
        openCount: action.payload.openCount,
        isPending: false
      }
    }

    case ActionTypes.Alerts.GET_ALERT_DETAILS_SUCCESS: {
      return {
        ...state,
        alertDetail: action.payload.alertDetail,
        isPending: false,
        isPendingGraph: false
      }
    }

    case ActionTypes.Alerts.GET_ALERTS_LIST_FAIL: {
      return {
        ...state,
        error: action.payload.error,
        isPending: false
      }
    }
    case ActionTypes.Alerts.GET_ALERT_DETAILS_FAIL: {
      return {
        ...state,
        error: action.payload.error,
        isPending: false,
        isPendingGraph: false
      }
    }
    case ActionTypes.Alerts.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    case ActionTypes.Alerts.REQUEST_PENDING_WITH_GRAPH: {
      return {
        ...state,
        alertDetail: action.payload.isPending
          ? ({} as AlertDetails)
          : state.alertDetail,
        isPending: action.payload.isPending,
        isPendingGraph: action.payload.isPending
      }
    }
    case ActionTypes.Alerts.DELETE_ALERT_SUCCESS: {
      return {
        ...state,
        isPending: false
      }
    }
    case ActionTypes.Alerts.DELETE_ALERT_FAIL: {
      return {
        ...state,
        isPending: false,
        error: action.payload.error
      }
    }

    case ActionTypes.Alerts.UPDATE_ALERT_SUCCESS: {
      return {
        ...state,
        isPending: false,
        alertDetail: {
          ...state.alertDetail,
          status: action.payload.status
        }
      }
    }
    case ActionTypes.Alerts.UPDATE_ALERT_FAIL: {
      return {
        ...state,
        isPending: false,
        error: action.payload.error
      }
    }

    case ActionTypes.Alerts.DISPOSE_ALERT: {
      return {
        ...state,
        alertsList: [],
        alertDetail: {} as AlertDetails,
        highCount: 0,
        mediumCount: 0,
        lowCount: 0,
        totalCount: 0,
        openCount: 0
      }
    }

    case ActionTypes.Alerts.DISPOSE_ALERTS: {
      return {
        ...state,
        alertsList: [],
        filter: Filter.defaultState
      }
    }

    case ActionTypes.Alerts.Filter.CHANGE_VIEW_BY_TIME: {
      return {
        ...state,
        filter: Filter.reducer(state.filter, action)
      }
    }

    default: {
      return state
    }
  }
}
